// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"b27283f8","45":"c50655a0","344":"fbc2222b","370":"7bc975f2","464":"16f66df6","475":"3890241b","526":"d4222adb","531":"75cb7a24","628":"a9bec7c7","805":"6724aa4a","910":"bd195299","950":"1c8469c3","967":"0d4a4a1d"}[chunkId] + ".chunk.js";
};